"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VARIANT_TYPES = exports.feedbackMessage = exports.feedbackMessageContainer = void 0;

var _stylitas = require("@creditas/stylitas");

const VARIANT_TYPES = {
  success: 'success',
  warning: 'warning',
  danger: 'danger',
  info: 'info'
};
exports.VARIANT_TYPES = VARIANT_TYPES;

const feedbackMessageContainer = ({
  theme
}) => (0, _stylitas.css)`
  display: flex;
  align-items: center;
  padding: 16px 16px 16px 8px;
  border: solid 1px ${theme.bColorneutral03};
  border-radius: 4px;
  background: ${theme.bColorneutral01};
  position: relative;
  overflow: hidden;

  > div {
    flex-shrink: 0;
  }
`;

exports.feedbackMessageContainer = feedbackMessageContainer;

const feedbackMessage = ({
  theme,
  variant
}) => {
  const color = `bColor${variant.toLowerCase()}`;
  return (0, _stylitas.css)`
    border-left: 8px solid ${theme[color]};
  `;
};

exports.feedbackMessage = feedbackMessage;